
const buttonRadioTpl = `Radio button`;

export { buttonRadioTpl }